/**
 * Formats partagés par la vitrine des bonnes affaires (refonte du 2026-09-14).
 */

export const nombre = (n) => Math.round(Number(n)).toLocaleString('fr-FR');

/** « Vue depuis N jours » : date où ZENKART a VU l'annonce, pas sa date de
 *  publication chez la source — d'où ce libellé et pas « En ligne depuis ». */
export function vueDepuis(jours) {
  if (jours == null) return '';
  if (jours === 0) return "Vue aujourd'hui";
  return `Vue depuis ${jours} jour${jours > 1 ? 's' : ''}`;
}

/* Compte connecté (2026-10-22) : depuis quand on n'a pas revu l'annonce
   (dernier passage d'un scraper ou dernier contrôle de lien réussi, calculé
   par le serveur). Le lien est ouvert, mais une annonce peut être partie
   entre-temps : la phrase le dit avant que l'acheteur se déplace. */
export function vueIlYA(jours) {
  if (jours == null) return 'Vérifiez qu’elle est encore en ligne.';
  const quand = jours === 0 ? 'aujourd’hui' : `il y a ${jours} jour${jours > 1 ? 's' : ''}`;
  return `Annonce vue ${quand}, vérifiez qu’elle est encore en ligne.`;
}

const SOURCES = {
  autoscout24: 'AutoScout24', autoscout24_de: 'AutoScout24.de', leboncoin: 'Leboncoin',
  lacentrale: 'La Centrale', paruvendu: 'ParuVendu', spoticar: 'Spoticar', aramisauto: 'Aramisauto',
  largus: 'L’argus', ouestfrance: 'Ouest-France Auto', zoomcar: 'Ouest-France Auto',
};

/* Nom lisible du site d'origine ; la valeur brute en repli. */
export function nomSource(source) {
  if (!source) return '';
  return SOURCES[String(source).toLowerCase()] || source;
}

export function lieu(a) {
  if (a.ville) return a.departement ? `${a.ville} (${a.departement})` : a.ville;
  if (a.departement_nom) return `${a.departement_nom} (${a.departement})`;
  return '';
}

const PALIERS_PUBLICS = ['SOLIDE', 'CORRECT'];

/** Annonce au format de l'API classique (favoris, historique, tableau de bord)
 *  -> carte de la vitrine. L'écart n'est posé que si la cote est publique ET
 *  que l'annonce est sous la cote : une carte ne montre jamais un écart
 *  défavorable en vert. */
export function carteDepuisAnnonce(l) {
  const cote = l.estimated_market_price;
  // Niveaux 1-2 du verdict (2026-09-15) : cote solide, ou indicative sous 25 %
  // d'écart — mêmes règles que app/services/niveaux_prix.
  const indicative = l.market_price_reliability === 'EXPLORATOIRE' && cote && l.price && cote - l.price <= l.price * 0.25;
  const fiable = (PALIERS_PUBLICS.includes(l.market_price_reliability) || indicative) && cote && l.price;
  const ecart = fiable ? cote - l.price : null;
  const sous = ecart != null && ecart > 0;
  const niveau = l.niveau_prix?.niveau || (fiable ? (indicative ? 'INDICATIVE' : 'SOLIDE') : null);
  const vu = l.first_seen_at ? new Date(l.first_seen_at) : null;
  return {
    id: l.id,
    marque: l.marque_libelle || l.brand || '',
    modele: l.modele_libelle || l.model || '',
    titre: l.title,
    annee: l.year,
    km: l.mileage,
    energie: l.fuel_type || null,
    prix: l.price,
    cote: sous ? cote : null,
    ecart_eur: sous ? Math.round(ecart) : null,
    ecart_pct: sous ? Math.round((ecart * 1000) / cote) / 10 : null,
    ville: null,
    departement: l.departement || null,
    departement_nom: l.departement_nom || null,
    photo: (l.images || []).find((i) => typeof i === 'string' && i.startsWith('http')) || null,
    vue_depuis_jours: vu && !Number.isNaN(vu.getTime()) ? Math.max(0, Math.floor((Date.now() - vu.getTime()) / 86400000)) : null,
    marge: l.potential_profit > 0 && l.margin_reliability ? Math.round(l.potential_profit) : null,
    niveau,
    niveau_prix: l.niveau_prix || null,
  };
}

export function nomVoiture(a) {
  return [a.marque, a.modele].filter(Boolean).join(' ') || a.titre || 'Voiture';
}

/** « GOLF » -> « Golf », « T-ROC » -> « T-Roc » ; « 208 », « BMW » intacts.
 *  Sorti de VerifierPage le 2026-10-15 (page supprimée) : /vendre et /trouver
 *  s'en servent pour afficher les modèles de la liste partagée. */
export function joli(texte) {
  if (!texte || texte !== texte.toUpperCase() || !/[A-Z]{4,}/.test(texte)) return texte;
  return texte.toLowerCase().replace(/(^|[\s-])([a-z])/g, (_, s, c) => s + c.toUpperCase());
}
